{
  "nl": {
    "toast": {
      "action": {
        "email_address_taken": "Dit e-mailadres hoort al bij een ander contact.",
        "failed": "Er trad een onverwachte fout op.",
        "impersonate_unauthorized": "Deze actie is niet toegestaan bij de impersonatie van een klant.",
        "storage_quota_exceeded": "Opslaglimiet bereikt. Verwijder bestanden of neem contact met ons op om je plan uit te breiden.",
        "succeeded": "Actie geslaagd",
        "task_assignment_document_required": "Deze taak heeft minstens één document nodig voordat je ze kunt voltooien.",
        "unprocessable": "Er is iets misgegaan. Vernieuw de pagina. Neem contact met ons op als het probleem aanhoudt.\nFOUT: {error}"
      },
      "create": {
        "failed": "{itemName} kon niet aangemaakt worden, gelieve opnieuw te proberen.",
        "succeeded": "{itemName} aangemaakt"
      },
      "delete": {
        "failed": "{itemName} kon niet verwijderd worden, gelieve opnieuw te proberen.",
        "succeeded": "{itemName} werd verwijderd",
        "succeeded_default": "Verwijderen is gelukt"
      },
      "update": {
        "failed": "{itemName} kon niet gewijzigd worden, gelieve opnieuw te proberen.",
        "succeeded": "{itemName} werd gewijzigd",
        "successfully_saved": "Succesvol opgeslagen"
      },
      "upload": {
        "failed": "Upload is mislukt",
        "succeeded": "Upload is gelukt"
      },
      "upload_document": {
        "extension_invalid": "Het document \"{document_name}\" heeft geen geldige extensie."
      },
      "upload_image": {
        "file_too_big": "Bestand te groot: maximale bestandsgrootte is 5 MB"
      },
      "warning": {
        "multipleFiles": "Deze export bevat meerdere zip-bestanden. Je browser kan mogelijks meerdere bestanden downloaden blokkeren. Neem contact op met Ziggu Support als je maar 1 zip-bestand kan downloaden."
      }
    }
  }
}
